export const heroSlides = [
  {
    id: "slide-about-time",
    movieId: "about-time",
    title: "时空恋旅人",
    subtitle: "平凡日子里的每一次心动，都值得被认真收藏",
    badge: "本周主推",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20banner%20of%20a%20couple%20walking%20hand%20in%20hand%20through%20a%20golden%20sunlit%20meadow%20at%20sunset%2C%20soft%20orange%20and%20cream%20tones%2C%20dreamy%20romantic%20atmosphere%2C%20gentle%20bokeh%2C%20wide%20composition%20with%20space%20for%20text%2C%20high%20detail%20art&width=1600&height=900&seq=hero-about-time&orientation=landscape",
  },
  {
    id: "slide-la-la-land",
    movieId: "la-la-land",
    title: "爱乐之城",
    subtitle: "当音乐响起，全世界只剩下你们两个人",
    badge: "情侣必看",
    image:
      "https://readdy.ai/api/search-image?query=Romantic%20cinematic%20banner%20of%20a%20couple%20dancing%20under%20warm%20string%20lights%20on%20a%20city%20rooftop%20at%20dusk%2C%20soft%20orange%20and%20cream%20tones%2C%20nostalgic%20jazz%20mood%2C%20dreamy%20glow%2C%20wide%20composition%20with%20space%20for%20text%2C%20high%20detail%20art&width=1600&height=900&seq=hero-la-la-land&orientation=landscape",
  },
  {
    id: "slide-your-name",
    movieId: "your-name",
    title: "你的名字。",
    subtitle: "跨越时间与距离，也要找到你",
    badge: "唯美动画",
    image:
      "https://readdy.ai/api/search-image?query=Breathtaking%20anime%20style%20banner%20of%20a%20glowing%20twilight%20sky%20with%20a%20comet%20and%20distant%20town%20silhouette%2C%20warm%20cream%20and%20orange%20gradient%2C%20soft%20rose%20accents%2C%20dreamy%20romantic%20mood%2C%20wide%20composition%20with%20space%20for%20text%2C%20high%20detail%20art&width=1600&height=900&seq=hero-your-name&orientation=landscape",
  },
  {
    id: "slide-notting-hill",
    movieId: "notting-hill",
    title: "诺丁山",
    subtitle: "最平凡的街角，也能遇见不平凡的爱情",
    badge: "都市童话",
    image:
      "https://readdy.ai/api/search-image?query=Charming%20cinematic%20banner%20of%20a%20cozy%20London%20street%20with%20a%20small%20bookshop%20and%20warm%20evening%20lights%20in%20autumn%2C%20soft%20orange%20and%20cream%20tones%2C%20storybook%20romantic%20mood%2C%20wide%20composition%20with%20space%20for%20text%2C%20high%20detail%20art&width=1600&height=900&seq=hero-notting-hill&orientation=landscape",
  },
  {
    id: "slide-little-forest",
    movieId: "little-forest",
    title: "小森林",
    subtitle: "一蔬一饭的安稳，就是我们向往的生活",
    badge: "治愈慢生活",
    image:
      "https://readdy.ai/api/search-image?query=Peaceful%20cinematic%20banner%20of%20a%20rustic%20countryside%20kitchen%20with%20fresh%20vegetables%20and%20warm%20morning%20light%20through%20the%20window%2C%20soft%20orange%20and%20cream%20tones%2C%20cozy%20slow%20living%20mood%2C%20wide%20composition%20with%20space%20for%20text%2C%20high%20detail%20art&width=1600&height=900&seq=hero-little-forest&orientation=landscape",
  },
];